var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c("div", [
        _c("div", { staticClass: "row q-mb-md" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c("q-btn", {
                attrs: {
                  push: "",
                  icon: "add",
                  label: "Add Question",
                  color: "primary"
                },
                on: { click: _vm.addQuestion }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c(
                "draggable",
                {
                  staticClass: "q-pa-md q-pb-lg drag-list",
                  attrs: {
                    options: _vm.groupOptions,
                    element: "q-list",
                    dense: "",
                    separator: ""
                  },
                  on: {
                    start: function($event) {
                      _vm.dragging = true
                    },
                    end: function($event) {
                      _vm.dragging = false
                    },
                    sort: _vm.handleQuestionSort
                  },
                  model: {
                    value: _vm.questions,
                    callback: function($$v) {
                      _vm.questions = $$v
                    },
                    expression: "questions"
                  }
                },
                [
                  _vm._l(_vm.questions, function(question, index) {
                    return [
                      !question.delete && !question.removalDate
                        ? _c(
                            "q-item",
                            {
                              key: question.sort,
                              staticClass: "sorting items-center handle",
                              attrs: { multiline: "", highlight: "" }
                            },
                            [
                              _c(
                                "q-item-side",
                                [
                                  _c("q-btn", {
                                    staticClass: "q-mr-sm",
                                    attrs: {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      icon: "edit",
                                      "text-color": "primary",
                                      disabled: _vm.loading
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editQuestion(index)
                                      }
                                    }
                                  }),
                                  _c("q-btn", {
                                    attrs: {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      icon: "delete",
                                      color: "negative",
                                      disabled: _vm.loading
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeQuestion(index)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item-main",
                                { class: [_vm.dragging ? "moving" : ""] },
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(_vm._s(question.questionText))
                                  ]),
                                  _c(
                                    "q-item-tile",
                                    { attrs: { sublabel: "" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("questionTypeDisplay")(
                                            question.questionType
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-item-side",
                                { attrs: { right: "" } },
                                [
                                  _c("q-icon", {
                                    attrs: {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      name: "drag_handle",
                                      color: "secondary"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              ),
              _c(
                "q-modal",
                {
                  attrs: {
                    "content-classes": "q-pa-lg",
                    "content-css": "min-width: 70%",
                    "no-route-dismiss": "",
                    "no-esc-dismiss": "",
                    "no-backdrop-dismiss": ""
                  },
                  model: {
                    value: _vm.questionModalOpen,
                    callback: function($$v) {
                      _vm.questionModalOpen = $$v
                    },
                    expression: "questionModalOpen"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "fit" },
                    [
                      _c("q-btn", {
                        staticStyle: {
                          top: "0",
                          right: "0",
                          position: "relative",
                          float: "right"
                        },
                        attrs: { flat: "", icon: "close" },
                        on: {
                          click: function($event) {
                            _vm.questionModalOpen = false
                          }
                        }
                      }),
                      _c(
                        "div",
                        [
                          _c("h4", [_vm._v("Question Editor/Creator")]),
                          _c(
                            "div",
                            { staticClass: "mdi-card full-width q-pa-md" },
                            [
                              _c(
                                "form",
                                {
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.saveQuestion.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            class: {
                                              "is-required": _vm.errors.has(
                                                "questionText",
                                                _vm.validatorFormName
                                              )
                                            },
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Question",
                                              inset: "full",
                                              icon: _vm.errors.has(
                                                "questionText",
                                                _vm.validatorFormName
                                              )
                                                ? "star_border"
                                                : "star",
                                              "icon-color": _vm.errors.has(
                                                "questionText",
                                                _vm.validatorFormName
                                              )
                                                ? "negative"
                                                : "blue-5",
                                              error: _vm.errors.has(
                                                "questionText",
                                                _vm.validatorFormName
                                              ),
                                              "error-label": _vm.errors.first(
                                                "questionText",
                                                _vm.validatorFormName
                                              ),
                                              helper:
                                                "Question to the registrant"
                                            }
                                          },
                                          [
                                            _c("q-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass: "no-shadow",
                                              attrs: {
                                                "data-vv-name": "questionText",
                                                type: "text",
                                                name: "questionText",
                                                "hide-underline": "",
                                                "inverted-light": "",
                                                color: _vm.errors.has(
                                                  "questionText"
                                                )
                                                  ? "negative"
                                                  : _vm.inputBgColor,
                                                "validator-form-name":
                                                  _vm.validatorFormName,
                                                "data-vv-scope":
                                                  _vm.validatorFormName
                                              },
                                              model: {
                                                value:
                                                  _vm.questionForm.questionText,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.questionForm,
                                                    "questionText",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "questionForm.questionText"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            class: {
                                              "is-required": _vm.errors.has(
                                                "invoiceDesc",
                                                _vm.validatorFormName
                                              )
                                            },
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Invoice Description",
                                              inset: "full",
                                              icon: _vm.errors.has(
                                                "invoiceDesc",
                                                _vm.validatorFormName
                                              )
                                                ? "star_border"
                                                : "star",
                                              "icon-color": _vm.errors.has(
                                                "invoiceDesc",
                                                _vm.validatorFormName
                                              )
                                                ? "negative"
                                                : "blue-5",
                                              error: _vm.errors.has(
                                                "invoiceDesc",
                                                _vm.validatorFormName
                                              ),
                                              "error-label": _vm.errors.first(
                                                "invoiceDesc",
                                                _vm.validatorFormName
                                              ),
                                              helper:
                                                "Description seen on Invoice"
                                            }
                                          },
                                          [
                                            _c("q-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass: "no-shadow",
                                              attrs: {
                                                "data-vv-name": "invoiceDesc",
                                                type: "text",
                                                name: "invoiceDesc",
                                                "hide-underline": "",
                                                "inverted-light": "",
                                                color: _vm.errors.has(
                                                  "invoiceDesc"
                                                )
                                                  ? "negative"
                                                  : _vm.inputBgColor,
                                                "validator-form-name":
                                                  _vm.validatorFormName,
                                                "data-vv-scope":
                                                  _vm.validatorFormName
                                              },
                                              model: {
                                                value:
                                                  _vm.questionForm.invoiceDesc,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.questionForm,
                                                    "invoiceDesc",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "questionForm.invoiceDesc"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Require Question",
                                              inset: "full",
                                              icon: "edit",
                                              "icon-color": _vm.inputBgColor,
                                              helper:
                                                "Require registrant to answer question"
                                            }
                                          },
                                          [
                                            _c("q-toggle", {
                                              attrs: {
                                                label: "Yes",
                                                name: "required"
                                              },
                                              model: {
                                                value:
                                                  _vm.questionForm.required,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.questionForm,
                                                    "required",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "questionForm.required"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Hide Question",
                                              inset: "full",
                                              icon: "edit",
                                              "icon-color": _vm.inputBgColor,
                                              helper:
                                                "Hide the question from the regisration form"
                                            }
                                          },
                                          [
                                            _c("q-toggle", {
                                              attrs: {
                                                label: "Yes",
                                                name: "hidden"
                                              },
                                              model: {
                                                value: _vm.questionForm.hidden,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.questionForm,
                                                    "hidden",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "questionForm.hidden"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            attrs: {
                                              orientation: "vertical",
                                              label:
                                                "Apply Question to All Attendees",
                                              inset: "full",
                                              icon: "edit",
                                              "icon-color": _vm.inputBgColor,
                                              helper:
                                                "Question will be presented to primary registrant and all additional attendees"
                                            }
                                          },
                                          [
                                            _c("q-toggle", {
                                              attrs: {
                                                label: "Yes",
                                                name: "appliesToAll"
                                              },
                                              model: {
                                                value:
                                                  _vm.questionForm.appliesToAll,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.questionForm,
                                                    "appliesToAll",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "questionForm.appliesToAll"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Show for Not Attending",
                                              inset: "full",
                                              icon: "edit",
                                              "icon-color": _vm.inputBgColor,
                                              helper:
                                                "If the registrant is not attending, but you still want them to see this question question, check this."
                                            }
                                          },
                                          [
                                            _c("q-toggle", {
                                              attrs: {
                                                label: "Yes",
                                                name: "appliesToAll"
                                              },
                                              model: {
                                                value:
                                                  _vm.questionForm
                                                    .showForNotAttending,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.questionForm,
                                                    "showForNotAttending",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "questionForm.showForNotAttending"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-xs-12 col-sm-12" },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            class: {
                                              "is-required": _vm.errors.has(
                                                "questionType",
                                                _vm.validatorFormName
                                              )
                                            },
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Question Type",
                                              inset: "full",
                                              icon: _vm.errors.has(
                                                "questionType",
                                                _vm.validatorFormName
                                              )
                                                ? "star_border"
                                                : "star",
                                              "icon-color": _vm.errors.has(
                                                "questionType",
                                                _vm.validatorFormName
                                              )
                                                ? "negative"
                                                : "blue-5",
                                              error: _vm.errors.has(
                                                "questionType",
                                                _vm.validatorFormName
                                              ),
                                              "error-label": _vm.errors.first(
                                                "questionType",
                                                _vm.validatorFormName
                                              )
                                            }
                                          },
                                          [
                                            _c("q-select", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass: "no-shadow",
                                              attrs: {
                                                options:
                                                  _vm.questionTypeOptions,
                                                "data-vv-name": "questionType",
                                                name: "questionType",
                                                "hide-underline": "",
                                                "inverted-light": "",
                                                color: _vm.errors.has(
                                                  "questionType"
                                                )
                                                  ? "negative"
                                                  : _vm.inputBgColor,
                                                "validator-form-name":
                                                  _vm.validatorFormName,
                                                "data-vv-scope":
                                                  _vm.validatorFormName
                                              },
                                              model: {
                                                value:
                                                  _vm.questionForm.questionType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.questionForm,
                                                    "questionType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "questionForm.questionType"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm.questionForm.questionType === "bool"
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                          },
                                          [
                                            _c(
                                              "q-field",
                                              {
                                                staticClass: "q-pa-md",
                                                attrs: {
                                                  orientation: "vertical",
                                                  label: "Cost Modifier",
                                                  inset: "full",
                                                  icon: "edit",
                                                  "icon-color":
                                                    _vm.inputBgColor,
                                                  helper:
                                                    "Checking yes to this question affects price by (can be positive or negative number)"
                                                }
                                              },
                                              [
                                                _c("q-input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required",
                                                      expression: "'required'"
                                                    }
                                                  ],
                                                  staticClass: "no-shadow",
                                                  attrs: {
                                                    type: "number",
                                                    name: "costModifier",
                                                    decimals: 2,
                                                    prefix: "$",
                                                    "hide-underline": "",
                                                    "inverted-light": "",
                                                    color: _vm.inputBgColor
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.questionForm
                                                        .costModifier,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.questionForm,
                                                        "costModifier",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "questionForm.costModifier"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.questionForm.questionType === "select"
                                    ? _c(
                                        "div",
                                        { staticClass: "row q-mb-md" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-12" },
                                            [
                                              _c("q-btn", {
                                                attrs: {
                                                  push: "",
                                                  icon: "add",
                                                  label: "Add Select Option",
                                                  color: "primary"
                                                },
                                                on: { click: _vm.addOption }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.questionForm.questionType === "select"
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-12" },
                                          [
                                            _vm.questionForm.questionOption
                                              ? _c(
                                                  "draggable",
                                                  {
                                                    staticClass:
                                                      "q-pa-md q-pb-lg drag-list",
                                                    attrs: {
                                                      options: _vm.groupOptions,
                                                      element: "q-list",
                                                      dense: "",
                                                      separator: ""
                                                    },
                                                    on: {
                                                      start: function($event) {
                                                        _vm.dragging = true
                                                      },
                                                      end: function($event) {
                                                        _vm.dragging = false
                                                      },
                                                      sort: _vm.handleOptionSort
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.questionForm
                                                          .questionOption,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.questionForm,
                                                          "questionOption",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "questionForm.questionOption"
                                                    }
                                                  },
                                                  [
                                                    _vm._l(
                                                      _vm.questionForm
                                                        .questionOption,
                                                      function(option, index) {
                                                        return [
                                                          !option.delete &&
                                                          !option.removalDate
                                                            ? _c(
                                                                "q-item",
                                                                {
                                                                  key:
                                                                    option.id,
                                                                  staticClass:
                                                                    "sorting items-center handle",
                                                                  attrs: {
                                                                    multiline:
                                                                      "",
                                                                    id:
                                                                      option.id
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "q-item-side",
                                                                    [
                                                                      _c(
                                                                        "q-btn",
                                                                        {
                                                                          staticClass:
                                                                            "q-mr-sm",
                                                                          attrs: {
                                                                            flat:
                                                                              "",
                                                                            round:
                                                                              "",
                                                                            dense:
                                                                              "",
                                                                            icon:
                                                                              "edit",
                                                                            "text-color":
                                                                              "primary",
                                                                            disabled:
                                                                              _vm.loading
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.editOption(
                                                                                index
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "q-btn",
                                                                        {
                                                                          attrs: {
                                                                            flat:
                                                                              "",
                                                                            round:
                                                                              "",
                                                                            dense:
                                                                              "",
                                                                            icon:
                                                                              "delete",
                                                                            color:
                                                                              "negative",
                                                                            disabled:
                                                                              _vm.loading
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.removeOption(
                                                                                index
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "q-item-main",
                                                                    {
                                                                      class: [
                                                                        _vm.dragging
                                                                          ? "moving"
                                                                          : ""
                                                                      ]
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              option.optionText
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "q-item-side",
                                                                    {
                                                                      attrs: {
                                                                        right:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "q-icon",
                                                                        {
                                                                          attrs: {
                                                                            flat:
                                                                              "",
                                                                            round:
                                                                              "",
                                                                            dense:
                                                                              "",
                                                                            name:
                                                                              "drag_handle",
                                                                            color:
                                                                              "secondary"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e(),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-12" },
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            staticClass: "full-width",
                                            attrs: {
                                              color: "primary",
                                              push: "",
                                              size: "lg",
                                              disabled: false
                                            },
                                            on: { click: _vm.saveQuestion }
                                          },
                                          [_vm._v("Save")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _c("q-btn", {
                            staticClass: "q-mt-lg",
                            attrs: { color: "primary", label: "Close" },
                            on: {
                              click: function($event) {
                                _vm.questionModalOpen = false
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "q-modal",
                {
                  attrs: {
                    "content-classes": "q-pa-lg",
                    "content-css": "min-width: 60%",
                    "no-route-dismiss": "",
                    "no-esc-dismiss": "",
                    "no-backdrop-dismiss": ""
                  },
                  model: {
                    value: _vm.optionModalOpen,
                    callback: function($$v) {
                      _vm.optionModalOpen = $$v
                    },
                    expression: "optionModalOpen"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "fit" },
                    [
                      _c("q-btn", {
                        staticStyle: {
                          top: "0",
                          right: "0",
                          position: "relative",
                          float: "right"
                        },
                        attrs: { flat: "", icon: "close" },
                        on: {
                          click: function($event) {
                            _vm.optionModalOpen = false
                          }
                        }
                      }),
                      _c(
                        "div",
                        [
                          _c("h4", [_vm._v("Select Option Editor/Creator")]),
                          _c(
                            "div",
                            { staticClass: "mdi-card full-width q-pa-md" },
                            [
                              _c(
                                "form",
                                {
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.saveOption.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            class: {
                                              "is-required": _vm.errors.has(
                                                "optionText",
                                                _vm.validatorOptionFormName
                                              )
                                            },
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Option Name",
                                              inset: "full",
                                              icon: _vm.errors.has(
                                                "optionText",
                                                _vm.validatorOptionFormName
                                              )
                                                ? "star_border"
                                                : "star",
                                              "icon-color": _vm.errors.has(
                                                "optionText",
                                                _vm.validatorOptionFormName
                                              )
                                                ? "negative"
                                                : "blue-5",
                                              error: _vm.errors.has(
                                                "optionText",
                                                _vm.validatorOptionFormName
                                              ),
                                              "error-label": _vm.errors.first(
                                                "optionText",
                                                _vm.validatorOptionFormName
                                              ),
                                              helper:
                                                "Select option text representation"
                                            }
                                          },
                                          [
                                            _c("q-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass: "no-shadow",
                                              attrs: {
                                                "data-vv-name": "optionText",
                                                type: "text",
                                                name: "optionText",
                                                "hide-underline": "",
                                                "inverted-light": "",
                                                color: _vm.errors.has(
                                                  "optionText"
                                                )
                                                  ? "negative"
                                                  : _vm.inputBgColor,
                                                "validator-form-name":
                                                  _vm.validatorOptionFormName,
                                                "data-vv-scope":
                                                  _vm.validatorOptionFormName
                                              },
                                              model: {
                                                value:
                                                  _vm.optionForm.optionText,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.optionForm,
                                                    "optionText",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "optionForm.optionText"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Hide Option",
                                              inset: "full",
                                              icon: "edit",
                                              "icon-color": _vm.inputBgColor,
                                              helper:
                                                "Hide the question from the regisration form"
                                            }
                                          },
                                          [
                                            _c("q-toggle", {
                                              attrs: {
                                                label: "Yes",
                                                name: "hidden"
                                              },
                                              model: {
                                                value: _vm.optionForm.hidden,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.optionForm,
                                                    "hidden",
                                                    $$v
                                                  )
                                                },
                                                expression: "optionForm.hidden"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                      },
                                      [
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "q-pa-md",
                                            attrs: {
                                              orientation: "vertical",
                                              label: "Cost Modifier",
                                              inset: "full",
                                              icon: "edit",
                                              "icon-color": _vm.inputBgColor,
                                              helper:
                                                "Checking yes to this question affects price by (can be positive or negative number)"
                                            }
                                          },
                                          [
                                            _c("q-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass: "no-shadow",
                                              attrs: {
                                                type: "number",
                                                name: "costModifier",
                                                decimals: 2,
                                                prefix: "$",
                                                "hide-underline": "",
                                                "inverted-light": "",
                                                color: _vm.inputBgColor
                                              },
                                              model: {
                                                value:
                                                  _vm.optionForm.costModifier,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.optionForm,
                                                    "costModifier",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "optionForm.costModifier"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-12" },
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            staticClass: "full-width",
                                            attrs: {
                                              color: "primary",
                                              push: "",
                                              size: "lg",
                                              disabled: false
                                            },
                                            on: { click: _vm.saveOption }
                                          },
                                          [_vm._v("Save")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _c("q-btn", {
                            staticClass: "q-mt-lg",
                            attrs: { color: "primary", label: "Close" },
                            on: {
                              click: function($event) {
                                _vm.optionModalOpen = false
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }